import { Loader2Icon } from "lucide-react"

import { cn } from "@/shadcn/lib/utils"

export interface SpinnerProps extends React.ComponentProps<"svg"> {
  size?: number | string
  thickness?: number
  color?: string
}

function Spinner({ className, size = "1em", thickness = 3, color, style, ...props }: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("animate-spin", color && `text-${color}`, className)}
      style={{ strokeWidth: thickness, width: size, height: size, ...style }}
      {...props}
    />
  )
}

export { Spinner }
